/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ product: NonNullable<unknown> }} Keep_Save_Stay_ButtonInputs */

const en_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Keep purchase`);
	return /** @type {LocalizedString} */ (`Keep subscription`)
	
};

const id_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Pertahankan pembelian`);
	return /** @type {LocalizedString} */ (`Tetap berlangganan`)
	
};

const ms_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Kekalkan pembelian`);
	return /** @type {LocalizedString} */ (`Simpan langganan`)
	
};

const ca_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Mantén la compra`);
	return /** @type {LocalizedString} */ (`Mantenir la subscripció`)
	
};

const cs_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Zachovat nákup`);
	return /** @type {LocalizedString} */ (`Ponechat předplatné`)
	
};

const da_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Behold køb`);
	return /** @type {LocalizedString} */ (`Behold abonnementet`)
	
};

const de_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Kauf beibehalten`);
	return /** @type {LocalizedString} */ (`Abonnement beibehalten`)
	
};

const et_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Säilita ost`);
	return /** @type {LocalizedString} */ (`Jäta tellimus alles`)
	
};

const es_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Conservar compra`);
	return /** @type {LocalizedString} */ (`Mantener suscripción`)
	
};

const fr_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Conserver l’achat`);
	return /** @type {LocalizedString} */ (`Conserver l’abonnement`)
	
};

const hr_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Zadrži kupnju`);
	return /** @type {LocalizedString} */ (`Zadrži pretplatu`)
	
};

const it_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Mantieni acquisto`);
	return /** @type {LocalizedString} */ (`Mantieni abbonamento`)
	
};

const lv_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Paturēt pirkumu`);
	return /** @type {LocalizedString} */ (`Saglabāt abonementu`)
	
};

const lt_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Išlaikyti pirkimą`);
	return /** @type {LocalizedString} */ (`Išsaugoti prenumeratą`)
	
};

const hu_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Vásárlás megtartása`);
	return /** @type {LocalizedString} */ (`Előfizetés megtartása`)
	
};

const nl_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Aankoop behouden`);
	return /** @type {LocalizedString} */ (`Abonnement behouden`)
	
};

const nb_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Behold kjøp`);
	return /** @type {LocalizedString} */ (`Behold abonnementet`)
	
};

const pl_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Zachowaj zakup`);
	return /** @type {LocalizedString} */ (`Kontynuuj subskrypcję`)
	
};

const pt_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Continuar a compra`);
	return /** @type {LocalizedString} */ (`Continuar assinando`)
	
};

const ro_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Păstrează achiziția`);
	return /** @type {LocalizedString} */ (`Păstrează abonamentul`)
	
};

const sk_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Zachovať nákup`);
	return /** @type {LocalizedString} */ (`Ponechať predplatné`)
	
};

const sl_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Ohrani nakup`);
	return /** @type {LocalizedString} */ (`Ohranite naročnino`)
	
};

const fi_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Säilytä osto`);
	return /** @type {LocalizedString} */ (`Jatka tilausta`)
	
};

const sv_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Behåll köp`);
	return /** @type {LocalizedString} */ (`Behåll prenumerationen`)
	
};

const vi_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Giữ lại mua hàng`);
	return /** @type {LocalizedString} */ (`Giữ gói đăng ký`)
	
};

const tr_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Satın almayı sürdür`);
	return /** @type {LocalizedString} */ (`Aboneliği sürdür`)
	
};

const el_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Διατήρηση αγοράς`);
	return /** @type {LocalizedString} */ (`Διατήρηση συνδρομής`)
	
};

const bg_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Запазване на покупката`);
	return /** @type {LocalizedString} */ (`Запази абонамента`)
	
};

const ru_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Сохранить покупку`);
	return /** @type {LocalizedString} */ (`Сохранить подписку`)
	
};

const sr_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Задржи куповину`);
	return /** @type {LocalizedString} */ (`Задржи претплату`)
	
};

const uk_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Зберегти покупку`);
	return /** @type {LocalizedString} */ (`Зберегти підписку`)
	
};

const ka_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`შეძენის შენარჩუნება`);
	return /** @type {LocalizedString} */ (`გამოწერის შენარჩუნება`)
	
};

const hi_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`खरीद रखें`);
	return /** @type {LocalizedString} */ (`सब्सक्रिप्शन जारी रखें`)
	
};

const th_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`เก็บการซื้อไว้`);
	return /** @type {LocalizedString} */ (`เป็นสมาชิกต่อไป`)
	
};

const ko_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`구매 유지`);
	return /** @type {LocalizedString} */ (`구독 유지`)
	
};

const zh_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`继续订阅`)
};

const zh_tw_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`保留購買`);
	return /** @type {LocalizedString} */ (`保留訂閱`)
	
};

const ja_keep_save_stay_button = /** @type {(inputs: Keep_Save_Stay_ButtonInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`購入を維持`);
	return /** @type {LocalizedString} */ (`サブスクリプションを継続`)
	
};

/**
* | product | output |
* | --- | --- |
* | "origin" | "Keep purchase" |
* | * | "Keep subscription" |
*
* @param {Keep_Save_Stay_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const keep_save_stay_button = /** @type {((inputs: Keep_Save_Stay_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keep_Save_Stay_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_keep_save_stay_button(inputs)
	if (locale === "ms") return ms_keep_save_stay_button(inputs)
	if (locale === "ca") return ca_keep_save_stay_button(inputs)
	if (locale === "cs") return cs_keep_save_stay_button(inputs)
	if (locale === "da") return da_keep_save_stay_button(inputs)
	if (locale === "de") return de_keep_save_stay_button(inputs)
	if (locale === "et") return et_keep_save_stay_button(inputs)
	if (locale === "es") return es_keep_save_stay_button(inputs)
	if (locale === "fr") return fr_keep_save_stay_button(inputs)
	if (locale === "hr") return hr_keep_save_stay_button(inputs)
	if (locale === "it") return it_keep_save_stay_button(inputs)
	if (locale === "lv") return lv_keep_save_stay_button(inputs)
	if (locale === "lt") return lt_keep_save_stay_button(inputs)
	if (locale === "hu") return hu_keep_save_stay_button(inputs)
	if (locale === "nl") return nl_keep_save_stay_button(inputs)
	if (locale === "nb") return nb_keep_save_stay_button(inputs)
	if (locale === "pl") return pl_keep_save_stay_button(inputs)
	if (locale === "pt") return pt_keep_save_stay_button(inputs)
	if (locale === "ro") return ro_keep_save_stay_button(inputs)
	if (locale === "sk") return sk_keep_save_stay_button(inputs)
	if (locale === "sl") return sl_keep_save_stay_button(inputs)
	if (locale === "fi") return fi_keep_save_stay_button(inputs)
	if (locale === "sv") return sv_keep_save_stay_button(inputs)
	if (locale === "vi") return vi_keep_save_stay_button(inputs)
	if (locale === "tr") return tr_keep_save_stay_button(inputs)
	if (locale === "el") return el_keep_save_stay_button(inputs)
	if (locale === "bg") return bg_keep_save_stay_button(inputs)
	if (locale === "ru") return ru_keep_save_stay_button(inputs)
	if (locale === "sr") return sr_keep_save_stay_button(inputs)
	if (locale === "uk") return uk_keep_save_stay_button(inputs)
	if (locale === "ka") return ka_keep_save_stay_button(inputs)
	if (locale === "hi") return hi_keep_save_stay_button(inputs)
	if (locale === "th") return th_keep_save_stay_button(inputs)
	if (locale === "ko") return ko_keep_save_stay_button(inputs)
	if (locale === "zh") return zh_keep_save_stay_button(inputs)
	if (locale === "zh-tw") return zh_tw_keep_save_stay_button(inputs)
	if (locale === "ja") return ja_keep_save_stay_button(inputs)
	return en_keep_save_stay_button(inputs)
});